import React, { useState, useEffect } from 'react';
import { getFrontendBuildInfo } from '@/lib/version';
import { apiRequest } from '@/lib/queryClient';

interface VersionInfo {
  frontend: {
    version: string;
  };
  backend: {
    version: string;
  } | null;
}

export default function ProfileVersionBanner() {
  const [versionInfo, setVersionInfo] = useState<VersionInfo | null>(null);

  useEffect(() => {
    const fetchVersionInfo = async () => {
      try {
        // Get frontend version
        const frontendInfo = getFrontendBuildInfo();
        
        // Try to get backend version
        let backendInfo = null;
        try {
          const response = await apiRequest('GET', '/api/version');
          backendInfo = await response.json();
        } catch (error) {
          console.warn('Could not fetch backend version:', error);
        }

        setVersionInfo({
          frontend: {
            version: frontendInfo.version
          },
          backend: backendInfo ? {
            version: backendInfo.version
          } : null
        });
      } catch (error) {
        console.error('Error fetching version info:', error);
      }
    };

    fetchVersionInfo();
  }, []);

  if (!versionInfo) {
    return null;
  }

  return (
    <div className="bg-padel-green text-white p-3 sm:p-4 shadow-lg">
      <div className="flex items-center space-x-3">
        <div className="text-sm font-medium">Version</div>
        <div className="flex items-center space-x-2">
          <span className="bg-white bg-opacity-20 px-2 py-1 rounded text-xs font-mono">
            Frontend: {versionInfo.frontend.version}
          </span>
          {versionInfo.backend && (
            <span className="bg-white bg-opacity-20 px-2 py-1 rounded text-xs font-mono">
              Backend: {versionInfo.backend.version}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
